export const removeParamsFromUrl = ( url ) => {
	const urlObj = new URL( url );
	urlObj.search = ''; // Clear the query string
	return urlObj.toString();
};

export default removeParamsFromUrl;
